import React from 'react';
import { Statistics } from '../../modules';
import StatisticsContainer from './StatisticsContainer';

const ProductStatistics = () => (
    <StatisticsContainer>
        <Statistics />
    </StatisticsContainer>
);

export default ProductStatistics;